// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KDLxn","colBig":"styles_colBig__2vJGV","colSmall":"styles_colSmall__cBv7R"};